var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isUnlocked)?_c('span',{style:(_vm.color)},[_vm._v(" "+_vm._s(_vm.name)+" "+_vm._s(_vm.gainText)+". "),_c('br')]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }